var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "EDIT",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_9620",
    "data-name": "Rechteck 9620",
    width: 48,
    height: 48,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7637",
    "data-name": "Pfad 7637",
    d: "M34.338,6.591,10.146,30.783,6.669,39.824a1.167,1.167,0,0,0,1.509,1.507l9.039-3.477L41.408,13.663Zm0,2.829,4.242,4.243L17.587,34.657l-4.243-4.243ZM16.1,36.14l-6.9,2.652,2.651-6.9.07-.069,4.243,4.243Z",
    transform: "translate(0.408 0.408)",
    fill: "#161615"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.c2a8d97f47ed9407f3e8973189322c23.svg";